import { useCallback, useState } from 'react';
import type { Notify } from './shared';

/**
 * Clipboard copy with a short "Copied ✓" flash keyed per control, shared by
 * the banners, tables and group cards so every copy button behaves alike.
 */
export function useCopyFeedback(notify: Notify, flashMs = 1600) {
  const [copiedKey, setCopiedKey] = useState<string | null>(null);
  const copy = useCallback(
    async (key: string, text: string) => {
      try {
        await navigator.clipboard.writeText(text);
        setCopiedKey(key);
        window.setTimeout(() => setCopiedKey((k) => (k === key ? null : k)), flashMs);
      } catch {
        notify('error', 'Copy failed');
      }
    },
    [notify, flashMs],
  );
  return { copiedKey, copy };
}
